export const JOBSITE_ID_MAX_LENGTH: number = 10;
